import React from 'react';
import styled from 'styled-components';
//
import { useFetch } from 'utils';
import Loading from 'shared/loading';
//
import Video from './video';
//
export default ({ shortcode, ...rest }) => {
  if (!shortcode) {
    return null;
  }

  const fetchUrl = `https://www.instagram.com/p/${shortcode}/?__a=1`;

  const { response, error } = useFetch(fetchUrl);

  if (error) {
    console.log({ error });
    return null;
  }

  if (!response) {
    return <Loading />;
  }

  const {
    dimensions,
    display_url,
    video_url
  } = response.data.graphql.shortcode_media;

  if (!video_url) return null;

  return (
    <Wrap>
      <Video url={video_url} dimensions={dimensions} image={display_url} />
    </Wrap>
  );
};
//
const Wrap = styled.div``;
